module.exports = __webpack_public_path__ + "img/idcard-fm.53e5d885.png";